import { CONFIG } from "@/config";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
  { href: "#reviews", label: "Reviews" },
  { href: "#credentials", label: "Credentials" },
  { href: "#services", label: "Services" },
  { href: "#contact", label: "Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 border-b border-[#EAEAEA] bg-[#FCFCFC]/85 backdrop-blur"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-baseline gap-2" data-testid="nav-brand">
          <span className="font-display text-lg md:text-xl font-medium tracking-tight text-[#0A0A0B]">
            {CONFIG.businessName}
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[#4A4A52] hover:text-[#0A192F] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-book-cta"
            className="text-sm font-semibold text-white bg-[#0A192F] hover:bg-[#172A4A] transition-colors px-5 py-2.5"
          >
            Book a session
          </a>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 -mr-2 text-[#0A0A0B]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#EAEAEA] bg-[#FCFCFC] px-6 py-6 space-y-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="block text-base text-[#0A0A0B]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-book-cta"
            className="inline-block text-sm font-semibold text-white bg-[#0A192F] px-5 py-3"
          >
            Book a session
          </a>
        </div>
      )}
    </header>
  );
};
